import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import EventReservationForm from './forms/EventReservationForm';
import EventReservationList from './lists/EventReservationList';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import ModalEditor from "./ModalEditor";
import InvoiceEditor from "./invoiceEditor";
import {postData} from "../../utils/request";
import {connect} from "src/store";
import {showModal} from "../../actions";
import {Payments} from './paymentEditor';
import debounce from "../../utils/debounce";
import Confirm from "../form/Confirm";
import set from "../../utils/set";
import Payment from "./OperationList/Elements/Payment";
import get from "../../utils/get";
import TextInput from "../form/TextInput";
import {CurrencyFormatter, UnitFormatter} from "../../utils/formatters";
import Select from "../form/Select";
import AddressControl from "../form/AddressControl";
import CheckBox from '../form/CheckBox';
import { deleteComponent } from 'src/utils/components';
import moment from "moment";

class Finalize extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            priceLoading: false,
            values: JSON.parse(JSON.stringify(props.values))
        }
    }

    getValue = (name) => {
        return get(this.state.values, name, undefined);
    }

    setFieldValue = (field, value)  => {
        const newValues = JSON.parse(JSON.stringify(this.state.values));
        set(newValues, field, value);
        this.setState({
            values: newValues
        })
    }

    getProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props, ...this.props[name]};
        props.disabled = this.props.disabled || props.disabled;
        return props;
    }

    loadPrice = debounce(() => {
        this.setState({priceLoading: true});
        this.priceRequest = postData({
            action: this.props.componentConfig.componentname + '.calculateParticipantPrice',
            [this.props.componentConfig.idfield]: this.state.values[this.props.componentConfig.idfield],
            participant_qty: parseInt(this.state.values?.participant_qty || "0"),
        });
        this.priceRequest.then(({total_price}) => {
            this.setState({priceLoading: false, values: {...this.state.values, saleprice: total_price + ""}});
        });
    }, 300);

    componentDidUpdate(prevProps, prevState, prevContext) {
        this.priceRequest && this.priceRequest.abort();
        if (JSON.stringify(this.props.values) !== JSON.stringify(prevProps.values)) {
            this.setState({
                values: JSON.parse(JSON.stringify(this.props.values))
            });
        }
        if (
            this.state.values[this.props.componentConfig.idfield]
            &&
            prevState.values?.participant_qty + "" !== "" + this.state.values?.participant_qty
        ) {
            this.loadPrice();
        } else if (this.state.priceLoading) {
            this.setState({priceLoading: false});
        }
    }

    render() {
        const props = {...this.props};
        return <Confirm
            size="medium"
            disabled={props.isLoading}
            color="primary"
            className="pull-right"
            header="Véglegesítés"
            body={<Fragment>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Számlázási adatok</label>
                            <Select
                                objectValue={true}
                                name="customer"
                                component="partner"
                                labelKey="name"
                                valueKey="partner_id"
                                storeType="remote"
                                view={["address","telnum"]}
                                value={this.state.values.customer}
                                saveChanges={this.setFieldValue}
                                label={false}
                                {...this.props.getFieldProps("customer")}
                            />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            <AddressControl
                                disabled="disabled"
                                name="customer.address"
                                value={this.state.values.customer?.address}
                                label="Cím"
                                saveChanges={this.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <TextInput
                                name="participant_qty"
                                type="number"
                                value={parseInt(this.state.values.participant_qty || "0")}
                                formatter={(value) => UnitFormatter(value, "Fő")}
                                label="Résztvevők/Létszám"
                                saveChanges={this.setFieldValue}
                                {...this.props.getFieldProps("participant_qty")}
                            />
                        </div>
                    </div>
                    <div className="currency col-md-6">
                        <div className="form-group">
                            <TextInput
                                name="saleprice"
                                type="number"
                                value={parseInt(this.state.values.saleprice || "0")}
                                formatter={CurrencyFormatter}
                                className={this.props.getFieldProps("saleprice").isLoading ? "loading" : null}
                                label="Ár"
                                saveChanges={this.setFieldValue}
                                {...this.props.getFieldProps("saleprice")}
                            />
                        </div>
                    </div>
                </div>
                {this.state.values.saleprice + "" !== "" + this.props.values.saleprice ? <div className="row">
                    <div className="currency col-md-12">
                        <div className="form-group">
                            <TextInput
                                type="number"
                                value={parseInt(this.state.values.saleprice || "0") - parseInt(this.props.values.saleprice || "0")}
                                formatter={CurrencyFormatter}
                                label="Fizetendő"
                                disabled={true}
                            />
                        </div>
                    </div>
                    <Payment
                        props={{
                            values: this.state.values,
                            getFieldProps: this.getProps,
                            getProps: this.getProps,
                            getValue: this.getValue,
                            setFieldValue: (field, value) => {
                                let values = JSON.parse(JSON.stringify(this.state.values));
                                set(values, field, value);
                                this.setState({
                                    values
                                });
                            }
                        }}
                    />
                </div> : null}
            </Fragment>}
            acceptButton="Véglegesítés"
            onAccept={async () => {
                return this.props.processAction(async () => {
                    if (
                        this.state.values.saleprice + "" !== "" + this.props.values.saleprice
                        &&
                        Object.values(this.state.values.payment || {}).filter(Boolean).length === 0
                    ) {
                        throw new Error(`Kérlek adj meg egy fizetési módot!`);
                    }
                    const res = await postData({
                        id: this.state.values[this.props.componentConfig.idfield],
                        action: this.props.componentConfig.componentname + '.finalize',
                        data: {
                            customer: this.state.values.customer,
                            saleprice: this.state.values.saleprice,
                            payment: this.state.values.payment,
                            participant_qty: this.state.values.participant_qty,
                        }
                    });
                    this.setState({values: JSON.parse(JSON.stringify(this.props.values))});
                    this.props.reloadForm();
                    return res;
                })
            }}
            onCancel={() => {
                this.setState({values: JSON.parse(JSON.stringify(this.props.values))});
            }}
        >
            Véglegesítés
        </Confirm>;
    }
}

class EventReservationEditor extends React.Component {

    constructor(props) {
        super(props);
        let state = {
            listType: 'calendar',
            priceLoading: false,
        };
        if (this.props.values[this.props.componentConfig.idfield]) {
            if (moment(this.props.values.cancellation_deadline, "YYYY-MM-DD HH:mm:ss").toDate().getTime() <= new Date().getTime()) {
                state.cancel = true;
            }
        }
        this.state = state;
    }


    loadPrice = debounce(() => {
        this.setState({priceLoading: true});
        this.priceRequest = postData({
            action: this.props.componentConfig.componentname + '.calculateParticipantPrice',
            [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
            participant_qty: parseInt(this.props.values?.participant_qty || "0"),
        });
        this.priceRequest.then(({total_price}) => {
            this.setState({priceLoading: false});
            this.props.setFieldValue("saleprice", total_price + "");
        });
    }, 300);

    componentDidUpdate(prevProps, prevState, prevContext) {
        this.priceRequest && this.priceRequest.abort();
        if (this.state.priceLoading) {
            this.setState({priceLoading: false});
        }
        if (
            this.props.values[this.props.componentConfig.idfield]
            &&
            prevProps.values?.participant_qty + "" !== "" + this.props.values?.participant_qty
        ) {
            this.loadPrice();
        }
        if (this.props.values[this.props.componentConfig.idfield] !== prevProps.values[prevProps.componentConfig.idfield]) {
            if (this.props.values[this.props.componentConfig.idfield]) {
                if (moment(this.props.values.cancellation_deadline, "YYYY-MM-DD HH:mm:ss").toDate().getTime() <= new Date().getTime()) {
                    this.setState({
                        cancel: true
                    });
                } else {
                    this.setState({
                        cancel: undefined
                    });
                }
            } else {
                this.setState({
                    cancel: undefined
                });
            }
        }
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    getFieldProps = (name) => {
        const props = this.props.getFieldProps(name);
        props.disabled = props.disabled || props.pos !== undefined || this.props.values?.state + "" === "300";
        if (name === "saleprice") {
            props.isLoading = this.state.priceLoading;
        }
        return props;
    }

    render() {
        const ListBox = this.props.list || Box;
        const EditorBox = this.props.editor || BoxEditor;
        const state = parseInt(this.props.values?.state || "0");

        const actionButtons = [];

        const props = {...this.props, getFieldProps: this.getFieldProps};
        props.filter = Array.isArray(props.filter) ? [...props.filter] : (props.filter !== null && props.filter !== undefined ? [props.filter] : []);
        if(props.pos !== undefined) {
            props.filter = [
                ...props.filter, ...[
                    {
                        field: "event.locations.left",
                        value: props.pos.location.left,
                        operator: ">"
                    },
                    {
                        field: "event.locations.right",
                        value: props.pos.location.right,
                        operator: "<"
                    },
                    {
                        field: "event.locations.partner",
                        value: props.pos.partner.partner_id
                    }
                ]
            ];
        }

        actionButtons.push(
            <Button
                key="0"
                disabled={!props.dirty || props.isLoading}
                color="primary"
                className="pull-right"
                onClick={this.saveForm}
            >
                Mentés
            </Button>
        );

        if (this.props.values[this.props.componentConfig.idfield] && !this.props.values.eventpurchase && state < 200) {
            actionButtons.push(
                <Finalize key="3" {...props} />
            );
        }

        if (props.pos === undefined) {
            actionButtons.push(
            <Confirm
                header="Törlés"
                key="1"
                disabled={this.props.dirty}
                body={
                    <>
                        {
                            this.state.cancel !== undefined ?
                            <> Biztosan törlöd ezt a tételt?
                            <div>
                                <label className="control-label">&nbsp;</label>
                                <CheckBox
                                    name="cancel"
                                    value={1}
                                    checked={!this.state.cancel}
                                    label="Előleg visszafizetése"
                                    saveChanges={() => this.setState({"cancel": !this.state.cancel})}
                                />
                             </div>
                             </> : <>Biztos hogy törlöd ezt a tételt?<br/>Törlés esetén <strong>visszafizeted az előleget</strong>. Az előleget csak akkor nem kell vissza fizetni, ha a programhoz beállított "előleg visszatartása" napnyi vagy kevesebb idő van hátra az eseményig.</>
                        }
                    </>
                }
                acceptButton="Törlés"
                color="danger"
                timeout={3}
                onAccept={async () => {
                    await this.props.processAction(async () => {
                        await deleteComponent(this.props.componentConfig.componentname, {
                            [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                            cancel: this.state.cancel
                        });
                        this.list && this.list.refresh();
                    });
                }}
            >
                Törlés
            </Confirm>
            );
        }
        if (state === 125) {
            actionButtons.push(<Button
                key="2"
                disabled={this.props.isLoading}
                color="default"
                onClick={() => this.props.processAction(async () => {
                       return postData({
                           id: this.props.values[this.props.componentConfig.idfield],
                           action: this.props.componentConfig.componentname + '.resolvePending'
                       })
                   })
                }
            >
                Elfogadás
            </Button>
            );
        }

        return (
            <Fragment>
                <ListBox
                    {...props}
                    theme="default"
                    header="Foglalások"
                    footer={[
                        <Button key="0" disabled={this.props.isLoading} color="default" onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <EventReservationList
                        ref={(el) => this.list = el}
                        {...props}
                        loadForm={this.loadForm}
                    />
                </ListBox>
                <EditorBox
                    {...props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Foglalás"
                    footer={actionButtons}
                >
                    <EventReservationForm
                        ref={(form) => this.form = form}
                        {...props}
                    />
                </EditorBox>
                {
                    props.pos === undefined && props.values[props.componentConfig.idfield] && !props.values.eventpurchase
                    &&
                    <Fragment>
                        <Payments
                            {...props}
                            collapsed={!(state < 100 || state >= 300)}
                        />
                        <InvoiceEditor
                            pageSize={0}
                            listFilter={[
                                {
                                    field: "component",
                                    value: props.componentConfig.componentname
                                },{
                                    field: "component_id",
                                    value: props.values[props.componentConfig.idfield]
                                }
                            ]}
                            editor={ModalEditor}
                            selection={null}
                        />
                    </Fragment>
                }
            </Fragment>
        );
    }
}

export default connect((state) => ({
    till: state.app.till
}),{showModal})(createEditor({
    componentName: "EventReservation",
    WrappedComponent: EventReservationEditor,
    props: {
        componentActions: (action, data, params) => {
            // params.notExecutePayment = true;
            return {action,data,params};
        }
    }
}));
